// Recursive function to clean empty values
export  const cleanEmptyValues = (obj) => {
    const cleaned = {};
    
    Object.entries(obj).forEach(([key, value]) => {
        // Handle nested objects
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            const nestedClean = cleanEmptyValues(value);
            if (Object.keys(nestedClean).length > 0) {
                cleaned[key] = nestedClean;
            }
        }
        // Handle arrays
        else if (Array.isArray(value)) {
            const filteredArray = value.filter(Boolean);
            if (filteredArray.length > 0) {
                cleaned[key] = filteredArray;
            }
        }
        // Handle primitive values
        else if (value !== null && value !== undefined && value !== '') {
            cleaned[key] = value;
        }
    });

    return cleaned;
};